import React from "react";
import styled from "styled-components";
import { ResumeBtn } from "./Header";

const MobileMenu = ({ isOpen, setOpen }) => {
  return (
    <Container isOpen={isOpen}>
      <Sidebar isOpen={isOpen}>
        <MenuWrap>
          <a onClick={() => setOpen(false)} href="#about">
            <p>
              <span>01.</span>About
            </p>
          </a>
          <a onClick={() => setOpen(false)} href="#work">
            <p>
              <span>02.</span>Work
            </p>
          </a>
          <a onClick={() => setOpen(false)} href="#project">
            <p>
              <span>03.</span>Project
            </p>
          </a>
          <a onClick={() => setOpen(false)} href="#contact">
            <p>
              <span>04.</span>Contact
            </p>
          </a>
          <a onClick={() => setOpen(false)} href="/resume.pdf" target="_blank">
            <ResumeBtn className="resume-btn">Resume</ResumeBtn>
          </a>
        </MenuWrap>
      </Sidebar>
    </Container>
  );
};

export default MobileMenu;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9;
  transition: var(--transition);
  background: none;
  transform: ${(props) =>
    props.isOpen ? "translateX(0vw)" : "translateX(100vw)"};
`;

const Sidebar = styled.div`
  position: fixed;
  top: 0;
  left: auto;
  bottom: 0;
  right: 0;

  padding: 50px 10px;
  width: min(75vw, 400px);

  background-color: var(--light-navy);
  box-shadow: -10px 0px 30px -15px var(--navy-shadow);

  visibility: visible;
  transition: var(--transition);

  button {
    margin-left: 0px;
    margin-top: 15px;
  }
`;

const MenuWrap = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
  p {
    color: var(--lightest-slate);
    padding: 10px;
    margin: 0px 5px;
    font-size: var(--fz-xs);
    cursor: pointer;
    transition: var(--transition);
    &:hover {
      color: var(--green);
    }
  }
  p span {
    margin-right: 5px;
    color: var(--green);
    font-size: var(--fz-xxs);
  }
`;
